import Relay from "react-relay";
import PropTypes from "prop-types";

export default class CancelJobMutation extends Relay.Mutation {
	static propTypes = {
		job_id: PropTypes.string.isRequired,
	};

	getMutation() {
		return Relay.QL`mutation {cancelJob}`;
	}

	getFatQuery() {
		return Relay.QL`
            fragment on CancelJobPayload {
                job {
                    id,
                    realId,
                    status,
                    message,
                    stop
                }
            }
        `;
	}

	getConfigs() {
		return [
			{
				type: "REQUIRED_CHILDREN",
				children: [this.getFatQuery()],
			},
		];
	}

	getVariables() {
		return {
			job_id: this.props.job_id,
		};
	}
}
